import '../../../i18n';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ArticleReaderModal from '../../ArticleReaderModal';
import { FaRegEnvelope } from 'react-icons/fa';
import { emailPreviewText } from '../../../util/emailPreviewText';
import { PRIMARY_COLOR, PRIMARY_COLOR_4 } from '../../../appearance/Colors';

export default function EmailPreviewPlugin({ message, onOpenVideoWorkspace, isStarred = false }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const email = message?.email;
    if (!email) return null;
    const read = () => {
        if (typeof onOpenVideoWorkspace === 'function') {
            onOpenVideoWorkspace(message, {
                type: 'email',
                title: message.title,
                articleBody: email.text,
                sourcePlatform: 'email'
            });
        } else setOpen(true);
    };
    return (
        <>
        <Panel $isStarred={isStarred} role="button" tabIndex={0} data-message-interactive="true"
            aria-label={`${t('settings:emailForwardingRead')}: ${email.subject || message.title || ''}`}
            onClick={event => { event.stopPropagation(); read(); }}
            onKeyDown={event => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault(); event.stopPropagation(); read();
                }
            }}>
            <Header>
                <FaRegEnvelope aria-hidden="true" />
                <Subject>{email.subject || message.title}</Subject>
            </Header>
            <Details>
            {email.from ? <span>{t('settings:emailForwardingFrom', { sender: email.from })}</span> : null}
            </Details>
            {email.preview ? <Preview>{emailPreviewText(email.preview)}</Preview> : null}
        </Panel>
            <ArticleReaderModal
                isOpen={open}
                onRequestClose={() => setOpen(false)}
                title={message.title}
                articleBody={email.text}
                messageId={message.id}
                sourcePlatform="email"
            />
        </>
    );
}
const Panel = styled.section`
    --email-title-color: ${props => props.$isStarred ? PRIMARY_COLOR : 'rgba(255,255,255,.92)'};
    --email-detail-color: ${props => props.$isStarred ? PRIMARY_COLOR_4 : 'rgba(255,255,255,.55)'};
    --email-preview-color: ${props => props.$isStarred ? PRIMARY_COLOR_4 : 'rgba(255,255,255,.65)'};
    --email-icon-color: ${props => props.$isStarred ? PRIMARY_COLOR_4 : 'rgba(255,255,255,.5)'};
    cursor: pointer;
    transition: background .15s ease, border-color .15s ease;
    &:hover {
        background: ${props => props.$isStarred ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255,255,255,.075)'};
        border-color: ${props => props.$isStarred ? 'rgba(0, 0, 0, 0.16)' : 'rgba(255,255,255,.22)'};
    }
    &:focus-visible { outline: 2px solid #7ab0ff; outline-offset: 3px; }
    min-width: 0;
    margin: 0;
    padding: ${props => props.$isStarred ? '8px' : '14px 16px'};
    border: 1px solid ${props => props.$isStarred ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.1)'};
    border-radius: ${props => props.$isStarred ? '8px' : '12px'};
    background: ${props => props.$isStarred ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.035)'};
    color: ${props => props.$isStarred ? PRIMARY_COLOR : 'rgba(255, 255, 255, 0.9)'};
`;
const Header = styled.div`
    display: flex; align-items: flex-start; gap: 10px;
    svg { margin-top: 3px; flex-shrink: 0; color: var(--email-icon-color); font-size: 16px; }
`;
const Subject = styled.h4`
    margin: 0; min-width: 0; color: var(--email-title-color) !important; font-size: 15px; line-height: 1.45; font-weight: 600;
    overflow-wrap: anywhere;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
`;
const Details = styled.div`
    display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap;
    gap: 10px; margin-top: 8px; font-size: 12px; color: var(--email-detail-color);
    span { min-width: 0; overflow-wrap: anywhere; }

`;
const Preview = styled.p`
    margin: 10px 0 0 !important; font-size: 13px !important; line-height: 1.55 !important;
    color: var(--email-preview-color); overflow-wrap: anywhere;
    display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
`;
